function dataUrlBytes(dataUrl) {
  const comma = String(dataUrl).indexOf(",");
  const b64 = comma >= 0 ? String(dataUrl).slice(comma + 1) : String(dataUrl);
  return Math.ceil(b64.length * 0.75);
}

export default function compressImageFile(file, { maxEdge = 1920, quality = 0.82, maxBytes } = {}) {
  return new Promise((resolve, reject) => {
    if (file.size > 25 * 1024 * 1024) {
      reject(new Error("Bild ist größer als 25 MB."));
      return;
    }
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
      let width = Math.max(1, Math.round(img.width * scale));
      let height = Math.max(1, Math.round(img.height * scale));
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const encode = (w, h, q) => {
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, w, h);
        return canvas.toDataURL("image/jpeg", q);
      };
      let q = quality;
      let dataUrl = encode(width, height, q);
      if (maxBytes) {
        while (dataUrlBytes(dataUrl) > maxBytes && q > 0.64) {
          q = Math.max(0.64, q - 0.06);
          dataUrl = encode(width, height, q);
        }
        while (dataUrlBytes(dataUrl) > maxBytes && Math.max(width, height) > 1600) {
          width = Math.max(1, Math.round(width * 0.9));
          height = Math.max(1, Math.round(height * 0.9));
          dataUrl = encode(width, height, Math.max(q, 0.78));
        }
      }
      URL.revokeObjectURL(url);
      resolve(dataUrl);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Bild konnte nicht gelesen werden."));
    };
    img.src = url;
  });
}
